export enum EModelApiPaths {
    API = '/api',
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/system-api',
    THIRD_PARTY_API_BASE = '/third-party',

    DOWNLOAD_FILE = '/swevenne/download-File',
    DOWNLOAD_FILES = '/swevenne/download-multiple-files',

    USER_WEBSITE_LOGIN = '/swevenne/swevenne-login',
    SEND_EMAIL_OR_MOBILE_PIN = '/swevenne/send-email-or-mobile-pin',
    VERIFY_EMAIL_OR_MOBILE_PIN = '/swevenne/verify-email-or-mobile-pin',
    GET_REVIEW_IN_WEBSITE = '/swevenne/get-review-in-website',
    LOAD_BRANDS = '/swevenne/load-brands',

    RAZORPAY_CREATE_ORDER = '/swevenne/razorpay/razorpay-create-order',
    RAZORPAY_ORDER_STATUS = '/swevenne/razorpay/razorpay-order-status',

    SHIPROCKET_TRACK_YOUR_ORDER = '/swevenne/shiprocket/track-your-order',
    SHIPROCKET_CALCULATE_SHIPPING_CHARGE = '/swevenne/shiprocket/calculate-shipping-charge',

    PAYPAL_CREATE_ORDER = '/swevenne/paypal/create-order',
    PAYPAL_CAPTURE_ORDER = '/swevenne/paypal/capture-order',

    PAYTM_CREATE_ORDER = '/swevenne/paytm/paytm-create-order',
    PAYTM_ORDER_STATUS = '/swevenne/paytm/paytm-order-status',

    ORDER_CASH_ON_DELIVERY = '/swevenne/order-cash-on-delivery',

    SEARCH_QUERY = '/swevenne/search'
}
